// Available Genres for selection.
const genres = [
  "Absurdist",
  "Action",
  "Action-Comedy",
  "Adult",
  "Adventure",
  "Adventure-Comedy",
  "Afrofuturism",
  "Alien Invasion",
  "Alternate History",
  "American Gothic",
  "Animation",
  "Anthology",
  "Art House",
  "Biographical Documentary",
  "Biography",
  "Blaxploitation",
  "Buddy Comedy",
  "Children's",
  "Christmas",
  "Comedy",
  "Coming of Age",
  "Concert Film",
  "Conspiracy Thriller",
  "Costume Drama",
  "Courtroom Drama",
  "Crime",
  "Cyberpunk",
  "Dance Film",
  "Documentary",
  "Disaster",
  "Drama",
  "Dystopian",
  "Educational",
  "Erotic",
  "Espionage",
  "Exploitation",
  "Fairy Tale",
  "Family",
  "Family Drama",
  "Farce",
  "Femme Fatale",
  "Film Noir",
  "Found Footage",
  "Gangster",
  "Gay & Lesbian",
  "Gothic",
  "Heist",
  "Historical Drama",
  "History",
  "Home Invasion",
  "Horror",
  "Humanitarian",
  "Independent",
  "Infidelity Drama",
  "Inspirational",
  "Intellectual",
  "Journalism",
  "Juvenile Delinquency",
  "Kids' Fantasy",
  "Kitchen Sink Drama",
  "Kung Fu",
  "Legal Drama",
  "Live Action Animation",
  "Martial Arts",
  "Medical Drama",
  "Mockumentary",
  "Monster",
  "Music",
  "Music Documentary",
  "Musical",
  "Mystery",
  "Nature Documentary",
  "Neo-Noir",
  "New Hollywood",
  "Non-Fiction",
  "Obscure",
  "Parody",
  "Period Drama",
  "Philosophical",
  "Political Drama",
  "Post-Apocalyptic",
  "Psychological Thriller",
  "Queer Cinema",
  "Reality TV",
  "Revenge",
  "Road Movie",
  "Romance",
  "Romance-Comedy",
  "Romantic Drama",
  "Satire",
  "Sci-Fi",
  "Science Fantasy",
  "Short",
  "Slice of Life",
  "Sport",
  "Superhero",
  "Thriller",
  "War",
  "Western",
];

export default genres;
